import React from 'react';

export const Marquee = ({ text, reverse }) => (
  <div className="marquee">
    <div className="marquee-inner" style={{ animationDirection: reverse ? 'reverse' : 'normal' }}>
      {[...Array(4)].map((_, i) => <span className="marquee-text" key={i}>{text}</span>)}
    </div>
  </div>
);